<template>
  <div
    class="type-scale-n1 flex items-center justify-start px-4 flex-shrink-0"
    :style="style"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppTableCell',

  props: {
    width: null
  },

  computed: {
    style() {
      return {
        width: this.width ? this.width + 'px' : null
      }
    }
  }
}
</script>
